<template>
  <div :class="['arrow-wrap', arrowSettings.arrowDirection]" :style="{ top: arrowSettings.top }">
    <div :class="['arrow', arrowSettings.arrowSize]">
      <div class="arrow-data" v-if="perfKey !== null && perfKey !== undefined && perfKey !== ''">
        <span class="label">{{setLabel(perfRecords[`${perfKey}/RSCNAME`])}}</span>
        <span class="data">
          <w-rsc-perf-event-text-label :perf-records="perfRecords" :perf-key="perfKey" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import WRscPerfEventTextLabel from '@/components/textLabel/RscPerfEventTextLabel';
import isNil from 'lodash/isNil';

export default {
  name: 'WFlowMapFlowField',
  components: {
    WRscPerfEventTextLabel,
  },
  props: {
    perfRecords: {
      type: Object,
    },
    perfKey: {
      type: String,
    },
    /**
     * Arrow 컴포넌트의 설정(위치, 방향, 크기)
     * @type {Object} [top : 상단으로부터의 위치, arrowDirection : 화살표 방향, arrowSize : 화살표의 크기(모양)]
     */
    arrowSettings: {
      type: Object,
    },
    label: {
      type: String,
    },
  },
  methods: {
    setLabel(word) {
      return (isNil(this.label)) ? word : this.label;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapFlowField.vue